var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.988 7.996c0-3.867 3.133-7 7-7s7 3.133 7 7-3.132 7-7 7-7-3.132-7-7m5.586 0L4.831 9.74l1.415 1.414L7.988 9.41l1.743 1.743 1.414-1.414-1.742-1.743 1.742-1.743L9.732 4.84 7.988 6.582 6.245 4.839 4.831 6.253z"
})));
export default SvgError;